import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'transactionType',
    standalone: false
})
export class TransactionTypePipe implements PipeTransform {

  transform(value: unknown): unknown {
    let status = 'n/A'
    if(value ==='R') {
      status = 'Received'
    }else if(value ==='P'){
      status = 'Paid'
    }
    return status;
  }

}


